import React from 'react';
import { useTranslation } from "react-i18next";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import styles from './notFoundInfo.module.scss';

const NotFoundInfo = ({ phone, certificateName, bonus, isSending, sendBonuses }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span>{phone} {t('NSBonusModal.notReg')}</span>
      </div>
      <div className={styles.body}>
        <p style={{ margin: 0 }}>{certificateName}</p>
        <p style={{ margin: '12px 0' }}>{t('NSAssessment.bonuses')}:</p>
        <span>{bonus || 0}</span>
      </div>
      <ButtonFilled loading={isSending} onClick={sendBonuses}  className={styles.btn}>{t('confirm')}</ButtonFilled>
    </div>
  )
}

export default NotFoundInfo
